gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

$( document ).ready( function(){
    ScrollTrigger.refresh();
})

//Handling Scroll Position on Resize
var pageST = ScrollTrigger.create({});

var progress = 0;
ScrollTrigger.addEventListener("refreshInit", function() {
    progress = pageST.scroll() / ScrollTrigger.maxScroll(window);
});
ScrollTrigger.addEventListener("refresh", function() {
    pageST.scroll(progress * ScrollTrigger.maxScroll(window));
});

document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
$(window).resize(function(){
    document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
}) 

// Introudction 

// handling animations on section "introductions"
gsap.set(".perbacco-page-introduction-figure", {autoAlpha: 0});
gsap.to(".perbacco-page-introduction-figure", 3, {autoAlpha: 1, delay: 0.5});

ScrollTrigger.matchMedia({
    "(max-width: 480px)": function() {
        var introductionTimeline = gsap.timeline({
            scrollTrigger: { 
                trigger: document.querySelector(".perbacco-introduction-section"),
                start: "top top",
                end: "bottom top",
                pin: true, 
                scrub: 0.35,
                anticipatePin: 1
            }
        })
        
        introductionTimeline
            .to(".perbacco-introduction-content>h1", {opacity: 1, duration: 1})
            .to(".perbacco-introduction-content", {autoAlpha: 0, duration: 0.5});

        //introductionTimeline.progress(1).progress(0);
    },
    "(min-width: 481px)": function() {
        var introductionTimeline = gsap.timeline({
            scrollTrigger: { 
                trigger: document.querySelector(".perbacco-introduction-section"),
                start: "top top",
                end: () => "+=" + 1.5 * document.querySelector('.perbacco-introduction-section').offsetHeight,
                pin: true, 
                scrub: 0.35
            }
        })
        
        introductionTimeline
            .to(".perbacco-introduction-content>h1", {opacity: 1, duration: 1})
            .to(".perbacco-introduction-content", {autoAlpha: 0, duration: 0.5})
    }
})


// Functionalities
document.documentElement.style.setProperty('--flower-section-height', $("#perbacco-flower-functionality-figure").height() + $("#perbacco-flower-functionality-figure").offset().top - $("#perbacco-flower-functionality-section").offset().top + 'px');
document.documentElement.style.setProperty('--functionality-information-height', $(".perbacco-functionality-information").height() + 'px');

var multifunctionalTimeline = gsap.timeline({
    scrollTrigger: {
        markers: false,
        trigger: '.perbacco-multifunctional-section',
        start: "top -=100px",
        end: "300%",
        pin: true,
        anticipatePin: 1,
        scrub: 0.35
    }
});

gsap.set(".perbacco-functionality-section:not(#perbacco-clean-functionality-section)", {autoAlpha: 0});

multifunctionalTimeline
    .to("#perbacco-wine-functionality-section", {autoAlpha: 1, duration: 1})
    
    .to("#perbacco-wine-functionality-section .perbacco-functionality-variable-content", {duration: 1, autoAlpha: 0}, "+=2")
    .to("#perbacco-wine-functionality-figure", {duration: 1, autoAlpha: 0}, "<")

    
    .to("#perbacco-water-functionality-section", {autoAlpha: 1, duration: 1})
    
    .to("#perbacco-water-functionality-section .perbacco-functionality-variable-content", {duration: 1, autoAlpha: 0}, "+=2")
    .to("#perbacco-water-functionality-figure", {duration: 1, autoAlpha: 0}, "<")


    .to("#perbacco-flower-functionality-section", {autoAlpha: 1, duration: 1})
    .to("#perbacco-flower-functionality-section", {autoAlpha: 1, duration: 1}, "+=2")

document.documentElement.style.setProperty('--functionality-figure-width', $('#perbacco-flower-functionality-figure').width() + 'px');

    
// Galleria
const scrollbarWidth = $('body').prop("scrollWidth") - $('body').prop("clientWidth");
document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');

gsap.set(".perbacco-image-container:not(.perbacco-image-container-1)", {autoAlpha: 0});
$(".perbacco-carousel-dot").first().addClass("active");
var slideIndex = 1;

// Next/previous controls
function plusSlides(n) {
  showSlides(slideIndex + n);
}

// Thumbnail image controls
function currentSlide(n) {
  showSlides(n);
}

function showSlides(n) {
    if(n <= 0){
        n = 7;
    }
    gsap.timeline()
        .to(".perbacco-image-container-" + slideIndex, {autoAlpha: 0})
        .to(".perbacco-image-container-" + (((n - 1) % 7) + 1), {autoAlpha: 1}, "<")
    var i;
    var dots = document.getElementsByClassName("perbacco-carousel-dot");

    slideIndex = ((n - 1) % 7) + 1; 

    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    dots[slideIndex-1].className += " active";
}



$(".perbacco-carousel-container").on("touchstart",function(evt){
    handleTouchStartOnCarousel(evt)
});
$(".perbacco-carousel-container").on("touchend",function(evt){
    handleTouchMoveOnCarousel(evt)
});

var xDown = null;
var yDown = null;                                               

function handleTouchStartOnCarousel(evt) {  
    xDown = evt.touches[0].clientX;
    yDown = evt.touches[0].clientY;
    console.log(xDown, yDown)
}; 

function handleTouchMoveOnCarousel(evt) {
    if ( ! xDown ||  ! yDown) {
        return;
    }
    var xUp = evt.changedTouches[0].clientX;  
    var yUp = evt.changedTouches[0].clientY;  

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if(Math.abs(xDiff) > Math.abs(yDiff)){
        if ( xDiff < 0  ) {
            plusSlides(-1);
        } else {
            plusSlides(1);
        }  
    }

    /* reset values  */
    xDown = null;
    yDown = null;    
}

gsap.to('.perbacco-carousel-container', {
    scrollTrigger: {
        trigger: '.perbacco-carousel-section',
        start: "top -=100", 
        end:  "200%",
        pin: true,
        scrub: 0.4,
        anticipatePin: 1
    }
})

document.documentElement.style.setProperty('--footer-height', $('#footer').height() + "px");

$("#unico-go-to-the-top").click(function(){
    gsap.to(window, {duration: 2, scrollTo: "#header"});
})